import {
	buildGETContract,
	serializePathBasic,
	HttpStatus,
	CommonResponses,
} from "@/common/contracts";
import { z } from "zod";
import { ListUserHistoryInputSchema } from "./ListUserHistoryInput";
import { ListUserHistoryOutputSchema } from "./ListUserHistoryOutput";
import { UserRole } from "@/users/models/UserRole";

export const ListUserHistoryContract = buildGETContract({
	path: "/users/:userId/history",
	method: "GET",
	params: ListUserHistoryInputSchema.pick({ userId: true }),
	search: ListUserHistoryInputSchema.omit({ userId: true }),
	serializePath(
		params: z.infer<typeof this.params>,
		search: z.infer<typeof this.search>,
	) {
		return serializePathBasic(this.path, params, search);
	},

	response: z.discriminatedUnion("status", [
		...CommonResponses,
		z.object({
			status: z.literal(HttpStatus.Success),
			body: ListUserHistoryOutputSchema,
		}),
	]),
});
